var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFindADealershipSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.3457031,4,1,5.3457031,1,7v18c0,1.6542969,1.3457031,3,3,3h24c1.6542969,0,3-1.3457031,3-3V7 C31,5.3457031,29.6542969,4,28,4z M29,25c0,0.5517578-0.4482422,1-1,1H4c-0.5517578,0-1-0.4482422-1-1V7 c0-0.5517578,0.4482422-1,1-1h24c0.5517578,0,1,0.4482422,1,1V25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8183594,19.3017578C17.7255859,18.8154297,15.5166016,18,13,18s-4.7255859,0.8154297-5.8203125,1.3027344 C6.4628906,19.6230469,6,20.3398438,6,21.1289062V23h2l-0.0058594-1.8701172C8.9423828,20.7080078,10.8535156,20,13,20 s4.0576172,0.7080078,5,1.1289062V23h2v-1.8710938C20,20.3398438,19.5371094,19.6230469,18.8183594,19.3017578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,17c1.8525391,0,3.5-2.5166016,3.5-4.5c0-2.0605469-1.4394531-3.5-3.5-3.5s-3.5,1.4394531-3.5,3.5 C9.5,14.4833984,11.1474609,17,13,17z M13,11c0.953125,0,1.5,0.546875,1.5,1.5c0,1.1660156-1.0644531,2.5-1.5,2.5 s-1.5-1.3339844-1.5-2.5C11.5,11.546875,12.046875,11,13,11z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 4,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindADealershipSmall);
export default __webpack_public_path__ + "static/media/find-a-dealership--small.7a4ecbba586aa55924f077d8ab5739be.svg";
export { ForwardRef as ReactComponent };